import React from "react";
import {connect} from "react-redux";

export default Component => {
	const wrapper = props => <Component {...props} />;
	return connect(
		(
			{
				checkoutBasket,
				checkoutBasketAdditionData,
				checkoutBasketCountry,
				checkoutBasketDiscounts,
				checkoutBasketExpiry,
				checkoutBasketId,
				checkoutBasketLoading,
				checkoutBasketUpsells,
				checkoutOrderVouchers
			}
		) => (
			{
				checkoutBasket,
				checkoutBasketAdditionData,
				checkoutBasketCountry,
				checkoutBasketDiscounts,
				checkoutBasketExpiry,
				checkoutBasketId,
				checkoutBasketLoading,
				checkoutBasketUpsells,
				checkoutOrderVouchers
			}
		)
	)(wrapper);
};
